import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    options: Object,
  };

  disconnect() {
    if (this.chart !== undefined) {
      this.chart.dispose();
      this.chart = null;
    }
  }

  WorkbookBreakdownChart = () => {
    this.chart = window.echarts.init(document.getElementById('workbook-breakdown-chart'));
    const wb = this.optionsValue['workbooks-breakdown'];
    const options = {
      tooltip: {
        trigger: 'item',
      },
      series: [
        {
          name: 'Workbook Statistics',
          type: 'pie',
          radius: ['50%', '90%'],
          right: '-4%',
          color: this.optionsValue.colors,
          label: {
            show: false,
          },
          data: wb.map((entry) => ({ name: entry[0], value: entry[1] })),
        },
      ],
    };
    this.chart.setOption(options);
  };

  whenEchartsAvailable = () => {
    const interval = setInterval(() => {
      if (window.echarts !== undefined) {
        this.WorkbookBreakdownChart();
        window.onresize = () => {
          if (this.chart !== null) {
            this.chart.resize();
          }
        };
        clearInterval(interval);
      }
    }, 10);
  };

  initialize() {
    this.whenEchartsAvailable();
  }
}
